
import React, { useState } from 'react';
import '../blogs.module.css'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/pro-regular-svg-icons';
import ReplyComment from './ReplyComment';
import CommentOverflow from './CommentOverflow';
import AddReplyButton from './AddReplyButton';
import moment from 'moment';
import { isAdmin, isLoggedIn } from '../../../utils/localStorage';

const OriginalComment = ({comment, refetch}) => {

    const [overflow,setOverflow] = useState(false);
    const [reply,setReply] = useState(true);
    const [input,setInput] = useState(false);
    const [content,setContent] = useState("");

    const toggleOverflow = () => {setOverflow(!overflow)}
    const toggleReply = () => {setReply(!reply)}
    const toggleInput = () => {setInput(!input)}

    const handleContentChange = (event) => {
        setContent(event.target.value);
    };

    const OverflowButton = () => {
        if (isAdmin()){
            return <div className='overflowButton' onClick={toggleOverflow}>⋮</div>
        }
        else return null
    }
    const replyToggleText = comment.replies.length > 0 ? (
        reply ? (
          <c>·&nbsp;<a onClick={toggleReply}>Hide replies</a>&nbsp;</c>
        ) : (
          <c>·&nbsp;<a onClick={toggleReply}>Show replies</a>&nbsp;</c>
        )
      ) : "";
      
      const inputToggleText = isLoggedIn() ? (
        input ? (
          <c>·&nbsp;<a onClick={toggleInput}>Cancel</a>&nbsp;</c>
        ) : (
          <c>·&nbsp;<a onClick={toggleInput}>Reply</a>&nbsp;</c>
        )
      ) : null;
      


    return (
        <div className='commentChain'>
            <div className='originalComment'>
                <div className='commentInfo'>
                    <img className='commentImage' src={'https://cdn-images-1.medium.com/fit/c/150/150/1*PhVZXKzCrkmS9ADYRi23Yg.png'}/>
                    <div className='commentNameDate'>
                        <div className='commentName'> {comment.commentedBy} </div>
                        <div className='commentDate'> {moment(comment.commentedAt).fromNow()} </div>
                    </div>
                    <OverflowButton/>
                </div>
                {overflow?<CommentOverflow comment={comment} refetch={refetch}/>:""}
                <div className='commentContent'>
                    {comment.body}
                </div>
                <div className='commentFooter'>
                    <FontAwesomeIcon icon={faComment}/> &nbsp;
                    {comment.replies.length} &nbsp;
                    {replyToggleText}
                    {inputToggleText}
                </div>
            </div>
                <div className='replyChain'>
                    {reply ? comment.replies.map(reply=> <ReplyComment reply={reply} refetch={refetch}/>):""}
                    {input?
                        <input className='replyInput' placeholder='Reply...' value={content} onChange={handleContentChange}/>
                    :""}
                    {input?
                        <AddReplyButton commentId={comment.id} content={content} refetchBlog={refetch} setContent={setContent} />
                    :""}
                </div>
        </div>
    )
}

export default OriginalComment;


// WEBPACK FOOTER //
// ./src/components/Blogs/Comments/OriginalComment.js